import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import { UpdateNetworkConfig } from 'src/Admin/utils/common';
import { axiosInstance } from 'src/api/axios';
import { GetCustomNetworkList } from 'src/redux/app/api-calls/configCalls';
import ToastMessage from '../../common/ToastMessage';
import GenericSkeleton from '../../common/skeleton/GenericSkeleton';
import GenericButton from '../../../../Components/GenericButton/GenericButton';
import WarningComponent from '../WarningComponent';
import './claims-configuration-table.scss';
import Checkbox from '../../common/Checkbox';

function ClaimsConfigurationTable() {
  const dispatch = useDispatch();
  const { Network_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const labelSelectionCount =
    Network_Setting?.Display_Last_Five_Claims_In_Dashboard === true ? 3 : 4;

  const [rows, setRows] = useState([]);
  const [oldRowsData, setOldRowsData] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [valuesChanged, setValueChanged] = useState(false);
  const [activeDisplayOnDashboardLabels, setActiveDisplayOnDashboardLabels] =
    useState([]);

  const [loader, setLoader] = useState(false);

  const updateClaimList = async (updatedRecords) => {
    const saveJson = {
      ClaimStatusLabels: updatedRecords,
    };
    return await axiosInstance.put(
      APIEndpoints.updateStatusLabels(),
      JSON.stringify(saveJson),
    );
  };

  const dismissAllToast = () => toast.dismiss();

  const updateDataApiCallHandler = async () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    try {
      const updateNetworkResponce = await updateClaimList([...rows]);
      if (
        HttpSuccessCodes.HTTP_SUCCESS_CODE_200 === updateNetworkResponce.status
      ) {
        toast.success(
          <ToastMessage
            type="success"
            subTitle={'Labels updated successfully'}
          />,
          setEditMode(false),
          setValueChanged(false),
        );
      }
    } catch (error) {
      console.log(error);
      if (error.toString().includes('409')) {
        toast.warning(
          <ToastMessage type="warning" subTitle={'Could not update labels.'} />,
        );
      } else {
        toast.error(
          <ToastMessage type="error" subTitle={'Label updation failed'} />,
        );
      }
    }
  };

  const updateRowValuesHandler = (value, intStatus, propertyName) => {
    dismissAllToast();
    let statusName = '';
    const updatedLabels = [...activeDisplayOnDashboardLabels];
    if (propertyName === 'Display_On_Dashboard') {
      rows.map((eachStatus) => {
        if (eachStatus.InternalStatus === intStatus) {
          statusName = eachStatus.ExternalStatusMemberDependent;
          if (
            activeDisplayOnDashboardLabels.includes(
              eachStatus.ExternalStatusMemberDependent,
            )
          ) {
            //const updatedLabels = [ ...activeDisplayOnDashboardLabels ];
            updatedLabels.splice(
              updatedLabels.indexOf(eachStatus.ExternalStatusMemberDependent),
              1,
            );
            setActiveDisplayOnDashboardLabels(updatedLabels);
          } else {
            //const updatedLabels = [ ...activeDisplayOnDashboardLabels ];
            updatedLabels.push(eachStatus.ExternalStatusMemberDependent);
            if (
              updatedLabels?.length <= labelSelectionCount &&
              propertyName === 'Display_On_Dashboard'
            ) {
              setActiveDisplayOnDashboardLabels(updatedLabels);
            }
          }
        }
      });
    } else if (propertyName === 'Display_On_Portal') {
      rows.map((eachStatus) => {
        if (eachStatus.InternalStatus === intStatus) {
          statusName = eachStatus.ExternalStatusMemberDependent;
        }
      });
    } else if (propertyName === 'Supress_Payment_Information') {
      rows.map((eachStatus) => {
        if (eachStatus.InternalStatus === intStatus) {
          statusName = eachStatus.ExternalStatusMemberDependent;
        }
      });
    }
    if (
      (updatedLabels?.length <= labelSelectionCount &&
        propertyName === 'Display_On_Dashboard') ||
      !value ||
      propertyName === 'Display_On_Portal' ||
      propertyName === 'Supress_Payment_Information' ||
      propertyName === 'ExternalStatus'
    ) {
      const rowsData = [...rows];
      const updatedData = [];
      rowsData.map((data, index) => {
        const { ChgUser, LastUpdated, ...updatedInfo } = data;
        if (
          data.InternalStatus === intStatus ||
          data.ExternalStatusMemberDependent === statusName
        ) {
          if (propertyName === 'ExternalStatusMemberDependent') {
            updatedInfo.ExternalStatusMemberDependent = value;
          }
          if (propertyName === 'Display_On_Dashboard') {
            updatedInfo.DisplayOnDashboard = value;
          }
          if (propertyName === 'Display_On_Portal') {
            updatedInfo.DisplayOnPortal = value;
          }
          if (propertyName === 'Supress_Payment_Information') {
            updatedInfo.SupressPaymentInformation = value;
          }
        }
        updatedData.push(updatedInfo);
      });

      setValueChanged(true);
      setRows(updatedData);
    } else {
      toast.warning(
        <ToastMessage
          type="warning"
          subTitle={`You can not select more than ${labelSelectionCount} unique statuses for dashboard`}
        />,
      );
    }
  };
  console.log(rows, 'rows');
  const renderRow = (row) => {
    return (
      <tr key={row?.InternalStatus}>
        <td className="text-left pl-2">{row?.InternalStatus}</td>
        <td>
          <input
            type="text"
            id={`ExternalStatus_Label-${row?.NetworkID}`}
            name={`ExternalStatus_Label-${row?.NetworkID}`}
            className="w-100 border-1 input-field claim-label-configuration-portal-external-status-field"
            onChange={(e) => {
              updateRowValuesHandler(
                e.target.value,
                row?.InternalStatus,
                'ExternalStatusMemberDependent',
              );
            }}
            defaultValue={row?.ExternalStatusMemberDependent}
            disabled={!editMode}
          />
        </td>
        <td>
          <div className="d-flex flex-wrap align-items-center justify-content-center">
            <Checkbox
              inline
              id={`Display_On_Dashboard-${row?.InternalStatus}`}
              name={`Display_On_Dashboard-${row?.InternalStatus}`}
              key={`Display_On_Dashboard-${row?.InternalStatus}`}
              label=""
              className="d-none"
              value={row?.InternalStatus}
              onChange={(e) => {
                updateRowValuesHandler(
                  e.target.checked,
                  row?.InternalStatus,
                  'Display_On_Dashboard',
                );
              }}
              checked={row?.DisplayOnDashboard}
              isDisabled={!editMode}
            />
            {/*<label
              className="my-auto"
              htmlFor={`Display_On_Dashboard-${row?.InternalStatus}`}
            >
              YES
            </label> */}
          </div>
        </td>
        <td>
          <div className="d-flex flex-wrap align-items-center justify-content-center">
            <Checkbox
              inline
              id={`Display_On_Portal-${row?.InternalStatus}`}
              name={`Display_On_Portal-${row?.InternalStatus}`}
              key={`Display_On_Portal-${row?.InternalStatus}`}
              label=""
              className="d-none"
              value={row?.InternalStatus}
              onChange={(e) => {
                updateRowValuesHandler(
                  e.target.checked,
                  row?.InternalStatus,
                  'Display_On_Portal',
                );
              }}
              checked={row?.DisplayOnPortal}
              isDisabled={!editMode}
            />
            {/*<label
              className="my-auto"
              htmlFor={`Display_On_Portal-${row?.InternalStatus}`}
            >
              YES
            </label> */}
          </div>
        </td>
        <td>
          <div className="d-flex flex-wrap align-items-center justify-content-center">
            <Checkbox
              inline
              id={`Supress_Payment_Information-${row?.InternalStatus}`}
              name={`Supress_Payment_Information-${row?.InternalStatus}`}
              key={`Supress_Payment_Information-${row?.InternalStatus}`}
              label=""
              className="d-none"
              value={row?.InternalStatus}
              onChange={(e) => {
                updateRowValuesHandler(
                  e.target.checked,
                  row?.InternalStatus,
                  'Supress_Payment_Information',
                );
              }}
              checked={row?.SupressPaymentInformation}
              isDisabled={!editMode}
            />
            {/*<label
              className="my-auto"
              htmlFor={`Display_On_Portal-${row?.InternalStatus}`}
            >
              YES
            </label> */}
          </div>
        </td>
      </tr>
    );
  };

  useEffect(() => {
    setLoader(true);
    setEditMode(false);
    setValueChanged(false);
    const getResources = async () => {
      return await axiosInstance.get(`${APIEndpoints.getAllClaimLabelsLIst()}`);
    };
    (async () => {
      try {
        const resourceData = await getResources();
        const resourceList = resourceData?.data?.Response?.ClaimStatusLabels;
        if (resourceList?.length > 0) {
          const activeItems = [];
          resourceList.map((element) => {
            if (
              element?.DisplayOnDashboard &&
              !activeItems.includes(element.ExternalStatusMemberDependent)
            ) {
              activeItems.push(element.ExternalStatusMemberDependent);
            }
          });
          setActiveDisplayOnDashboardLabels(activeItems);
        }
        setRows(resourceList);
        setOldRowsData([...resourceList]);
      } catch (error) {
        console.error(error);
      } finally {
        setLoader(false);
      }
    })();
  }, []);

  return (
    <div>
      <div className="parent-div">
        <div>
          <h2>Configuration Table</h2>
        </div>
        <div className="text-right my-2">
          {rows.length > 0 && (
            <GenericButton
              onClick={() => setEditMode((prevState) => !prevState)}
              className="ml-1"
              disable={editMode}
              buttonDisabled={true}
            >
              {/*{editMode ? 'Disable Editing' : 'Enable Editing'} */}
              Edit
            </GenericButton>
          )}
        </div>
      </div>
      {editMode && (
        <div className="mb-3">
          <WarningComponent />
        </div>
      )}
      {/*as of now we are using existing skeleton, we need to create one skeleton for this table */}
      {loader ? (
        <GenericSkeleton />
      ) : (
        <div className="d-flex flex-column justify-content-center w-100">
          <table border={1} className="claim-label-configuration-table">
            <thead>
              <tr>
                <th className="pl-2">JV Core InternalStatus</th>
                <th>JMP Portal ExternalStatus</th>
                <th>Display on Dashboard</th>
                <th>Display on Portal</th>
                <th title="Supress Payment Information">
                  Supress Payment Info...
                </th>
              </tr>
            </thead>
            {!loader && (
              <tbody>
                {rows.map((row) => {
                  return renderRow(row);
                })}
              </tbody>
            )}
          </table>
          {editMode && (
            <div className="d-flex flex-wrap justify-content-end mt-5">
              <GenericButton
                className="mr-3"
                onClick={() => {
                  setEditMode(false);
                  setValueChanged(false);
                  window.scrollTo(0, 0);
                }}
                buttonDisabled={!editMode}
                disable={!editMode}
                variant="link"
              >
                Cancel
              </GenericButton>
              <GenericButton
                className="ml-1"
                disable={!valuesChanged || !editMode}
                onClick={() => updateDataApiCallHandler()}
                buttonDisabled={!valuesChanged || !editMode}
              >
                Save
              </GenericButton>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ClaimsConfigurationTable;
